import { render, staticRenderFns } from "./RequestIncidentsInfo.vue?vue&type=template&id=332ff3a7&"
import script from "./RequestIncidentsInfo.vue?vue&type=script&lang=js&"
export * from "./RequestIncidentsInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports